import React from "react";

export function PortalPage({ children, className = "", narrow = false }) {
  return (
    <div
      className={[
        "portal-page",
        "dashboard-content",
        "w-full",
        "space-y-6",
        "px-4",
        "py-8",
        narrow ? "portal-page--narrow" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}

export function PortalPageHead({ eyebrow, title, lede, meta }) {
  return (
    <header className="portal-page-head">
      {eyebrow ? <p className="portal-page-head__eyebrow">{eyebrow}</p> : null}
      {title ? <h1 className="portal-page-head__title">{title}</h1> : null}
      {lede ? <p className="portal-page-head__lede">{lede}</p> : null}
      {meta ? <p className="portal-page-head__meta">{meta}</p> : null}
    </header>
  );
}

export function PortalSectionTitle({ children, className = "" }) {
  return <h2 className={["portal-section-title", className].filter(Boolean).join(" ")}>{children}</h2>;
}
